export default {
  title: "Malicious Address Risk Monitoring",
  subtitle: "Transfer information of involved addresses in the last 24 hours",
  viewMore: "View More",
  statistics: {
    associatedAddresses: "Associated Addresses",
    totalTransactions: "Total Inbound Transactions",
    totalAmount: "Total Inbound Amount",
  },
};
